exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".fade-translate-enter {\n  opacity: 0;\n  position: fixed;\n  transform: translate(0, -3vh);\n}\n\n.fade-translate-enter.fade-translate-enter-active {\n  opacity: 1;\n  transform: translate(0, 0);\n  transition: opacity 0.5s ease-in, transform 0.3s ease-in-out;\n}\n\n.fade-translate-exit {\n  opacity: 1;\n  position: fixed;\n  transform: translate(0, 0);\n}\n\n.fade-translate-exit.fade-translate-exit-active {\n  opacity: 0;\n  transform: translate(0, 3vh);\n  transition: opacity 0.3s ease-in, transform 0.3s ease-in-out;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/resolve-url-loader!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./src/components/enviroments/PageFade/PageFade.scss
// module id = 409
// module chunks = 0